import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import getMinutes from "date-fns/getMinutes";
import addMinutes from "date-fns/addMinutes";
import getHours from "date-fns/getHours";
import moment from "moment/moment";

export const getMinimumTimeForEndTime = (props) => {
    let minTime = setHours(setMinutes(new Date(), 30), 0);
    let hours = 0, minutes = 30;
    let date = new Date();

    if (props.start_time) {
        if (props.end_time > props.start_time) {
            //minTime =  setHours(setMinutes(new Date(), 30), 0);
        } else {
            //end time is less than or equal to start_time
            const getDateBasedOnStartTime = new Date(props.start_time)
            const thirtyMinutesFromNow = addMinutes(getDateBasedOnStartTime, 30)
            minutes = setMinutes(getDateBasedOnStartTime, getMinutes(thirtyMinutesFromNow));
            hours = getHours(getDateBasedOnStartTime);
            minTime = setHours(minutes, hours)
        }
    } else {
        date.setMinutes(date.getMinutes() + 30);
        hours = date.getHours();
        minutes = date.getMinutes();
        minTime = setHours(setMinutes(new Date(), minutes), hours);
    }

    return minTime;
};

export const getMaximumTimeForEndTime = (props) => {

    let maxTime = setHours(setMinutes(new Date(), 30), 0);
    let hours = 0, minutes = 30;
    let date = new Date();

    if (props.start_time) {
        if (props.end_time > props.start_time) {
            maxTime = setHours(
                setMinutes(
                    new Date(props.start_time),
                    getMinutes(
                        addMinutes(
                            new Date(props.start_time),
                            30
                        )
                    )
                ),
                getHours(new Date(props.start_time))
            )
        } else {
            maxTime = setHours(
                setMinutes(
                    new Date(props.start_time),
                    30
                ),
                23
            )
        }
    }

    return maxTime;
}

export const getEndTimeMinDate = (props) => {
    if (props.start_time) {
        return moment(props.start_time).local().toDate()
    } else {
        return moment().toDate()
    }
}

export const getEndTimeMaxDate = (props) => {
    if (props.start_time) {
        return moment(props.start_time).local().add(1, "days").toDate()
    } else {
        return moment().add(1, "days").toDate()
    }
}

export const getEndTimeMinTime = (props) => {
    let today = moment();
    return setHours(setMinutes(today, 30), 12);
}

export const getEndTimeMaxTime = (props) => {
    let today = moment();
    return setHours(setMinutes(today, 30), 23);
}